'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _F = require('ramda/src/F');

var _F2 = _interopRequireDefault(_F);

var _pipe = require('ramda/src/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _curried = require('./_curried');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ignoreElements = function ignoreElements(stream$) {
  return (0, _pipe2.default)((0, _curried.mfilterc)(_F2.default))(stream$);
};

exports.default = ignoreElements;